import PricingContent from "@/components/pricing/PricingContent";
import DynamicPageLayout from "@/components/layout/DynamicPageLayout";
import { auth } from "@clerk/nextjs/server";

export const metadata = {
  title: "Pricing - Vela",
  description: "Pay only for what you use. Simple, transparent pricing for small businesses.",
};

export default async function PricingPage() {
  const { userId } = await auth();

  return (
    <DynamicPageLayout pageKey="pricing">
      <div className={`${userId ? "p-6 lg:p-8" : "py-16 px-4 sm:px-6 lg:px-8"}`}>
        <div className="max-w-7xl mx-auto">
          <PricingContent showLayout={!userId} />
        </div>
      </div>
    </DynamicPageLayout>
  );
}
